import React, { useState, useEffect } from "react";
import { Nav, Navbar, Stack, Form } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import { BsPencilSquare } from "react-icons/bs";
import ListGroup from "react-bootstrap/ListGroup";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import axiosInstance from "../axiosApi";
import LoaderButton from "../components/LoaderButton";
import { useTranslation } from 'react-i18next';

function RoboCar() {
  const [cars, setCars] = useState([]);
  const { isAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  
  useEffect(() => {
    async function onLoad() {
      if (!isAuthenticated) {
        return;
      }
      
      try {
        axiosInstance.get('/robotaxi/robocar/').then(function(response) {
          const cars = response.data;
          setCars(cars);
        }).catch(function (error) {
          if ( error.response.status === 444 ) {
            onError(error.response.data.message);
          } else {
            onError(error);
          }
        });
      } catch (e) {
        onError(e);
      }
      
      setIsLoading(false);
    }
    
    onLoad();
  }, [isAuthenticated]);
  
  function renderCarsList(cars) {
    return (
      <>
        <LinkContainer to="/robocar/new">
          <ListGroup.Item action className="py-3 text-nowrap text-truncate">
            <BsPencilSquare size={17} />
            <span className="ml-2 font-weight-bold">Create a New Car</span>
          </ListGroup.Item>
        </LinkContainer>
        {cars.map(({ id, carname, car_status, car_direction, route, station, crt_date }) => (
          <LinkContainer key={id} to={`/robocar/${id}`}>
            <ListGroup.Item action>
              <span className="font-weight-bold">
                {carname}
              </span>
              <br />
              <span className="font-weight-bold">
                {car_status}
              </span>
              <br />
              <span className="font-weight-bold">
                {route.routename}
              </span>
              <br />
              <span className="font-weight-bold">
                {station.stationname}
              </span>
              <br />
              <span className="text-muted">
                Created: {new Date(crt_date).toLocaleString()}
              </span>
            </ListGroup.Item>
          </LinkContainer>
        ))}
      </>
    );
  }
  
  return (
  <Stack gap={3}>
      <div className="bg-light border titlesubject">
        {t('ROBOCARMGT')}
      </div>
      <div className="routes">
        <ListGroup>{!isLoading && renderCarsList(cars)}</ListGroup>
      </div>
        
      <div>
        <br /><br /><br />
      </div>
  </Stack>
  );
}

export default RoboCar;